/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/wards';

export const WardApi = {
  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
};
